import { COLOR_WHITE } from "#constants/Styles"
import { CircularProgress } from "@mui/material"
import Autocomplete from "@mui/material/Autocomplete"
import TextField from "@mui/material/TextField"
import { darken, lighten, styled } from "@mui/system"
import { Fragment, useCallback } from "react"

export default function InputAutocompleteGroup({
	value,
	setValue,
	groupBy,
	options = [],
	optionsId = null,
	optionsLabel = null,
	loading = false,
	fullWidth = true,
}) {
	const valueOption = useCallback(() => {
		if (optionsId) return options.find((opt) => opt[optionsId] === value) || null
		return value || null
	}, [optionsId, options, value])

	const labelOption = useCallback(
		(option) => {
			if (optionsLabel) return option ? option[optionsLabel] ?? "" : ""
			return option || null
		},
		[optionsLabel]
	)

	const onChangeValue = useCallback(
		(e, newValue) =>
			setValue(() => {
				if (optionsId) return newValue ? newValue[optionsId] : null
				return newValue ? newValue : null
			}),
		[optionsId, setValue]
	)

	return (
		<Autocomplete
			fullWidth={fullWidth}
			value={valueOption()}
			onChange={onChangeValue}
			options={
				groupBy ? options.sort((a, b) => a[groupBy].localeCompare(b[groupBy])) : options
			}
			groupBy={groupBy ? (option) => option[groupBy] : null}
			getOptionLabel={labelOption}
			loading={loading}
			renderInput={(params) => (
				<TextField
					{...params}
					label="Herramientas"
					InputProps={{
						...params.InputProps,
						endAdornment: (
							<Fragment>
								{loading ? <CircularProgress color="inherit" size={20} /> : null}
								{params.InputProps.endAdornment}
							</Fragment>
						),
					}}
				/>
			)}
			renderGroup={(params) => (
				<li key={params.key}>
					<GroupHeader>{params.group}</GroupHeader>
					<GroupItems>{params.children}</GroupItems>
				</li>
			)}
		/>
	)
}

const GroupHeader = styled("div")(({ theme }) => ({
	position: "sticky",
	top: "-8px",
	padding: "4px 10px",
	color: COLOR_WHITE,
	backgroundColor:
		theme.palette.mode === "light"
			? lighten(theme.palette.primary.light, 0.0)
			: darken(theme.palette.primary.main, 0.8),
}))

const GroupItems = styled("ul")({
	padding: 0,
})
